import {
    FETCH_JOKE_PENDING, 
    FETCH_JOKE_SUCCESS,
    FETCH_JOKE_FAILED
} from '../actions/types'

const INITIAL_STATE = {
    isPending: false,
    value: '',
    error: ''
}

export default (state = INITIAL_STATE, action = {}) => {
    const { type, payload } = action
    switch(type) {
        case FETCH_JOKE_PENDING:
            return { ...state, isPending: true }
        case FETCH_JOKE_SUCCESS: 
            return { ...state, value: payload, isPending: false }
        case FETCH_JOKE_FAILED: 
            return { ...state, error: payload, isPending: false }
        default:
            return state
    }
}